import React from "react";
import styled from "styled-components";
import Slide from "../../utils/images/her.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";

const Layout = styled.div`
  background: #f6f6f6;
  .banner-contents {
    height: 100%;
    width: 100%;
    display: grid;
    place-items: center;
    text-align: center;
  }
  .circle {
    height: 100px;
    width: 100px;
    border-radius: 100%;
    background: #fff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 33px;
    font-weight: 800;
    text-transform: uppercase;
    font-family: "Oswald", sans-serif;
  }
  .icon-wrap {
    display: flex;
    justify-content: center;
    margin-top: -60px;
  }
  .name {
    font-size: 40px;
    color: #fff;
    font-family: "Oswald", sans-serif;
  }
  p {
    color: #fff;
    font-size: 16px;
    font-family: "Oswald", sans-serif;
  }
`;

function AboutHer() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <div className="banner-contents">
            <div>
              <h1 className="name">Ufedo Favour</h1>
              <HeartStyle>
                <span className="white-line"></span>
                <HeartFilled
                  style={{ fontSize: 19, zIndex: 20, color: "red" }}
                />
                <HeartFilled
                  style={{
                    fontSize: 19,
                    marginLeft: -5,
                    color: "white",
                  }}
                />
                <span className="white-line"></span>
              </HeartStyle>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                ultrices malesuada ante quis
                <br /> pharetra. Nullam non bibendum dolor. Ut vel turpis
              </p>
            </div>
          </div>
        </div>
        <div className="icon-wrap">
          <span className="circle">
            <HeartFilled style={{ color: "red " }} />
          </span>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `url(${Slide})`,
    height: 510,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
  },
};
export default AboutHer;
